<template>
  <div>
    <!-- <div class="leave-message-btn" @click="openMessage">留言板</div> -->
    <div class="leave-message-box" v-if="messageBoxShow">
      <div class="leave-message-bg"></div>
      <div class="leave-message-content">
        <div class="message-head">
          <span>留言板</span>
          <div class="message-close" @click="closeMessage" v-if="!isOnly"></div>
        </div>
        <div class="message-content">
          <div class="message-inner-content">
            <el-scrollbar>
              <ul class="message-inner-ul" v-infinite-scroll="getMessageList" infinite-scroll-disabled="disabled">
                <li class="message-inner-item" :class="index%2==1 ? 'inner-item-extra' : ''" v-for="(messageItem, index) in messageList" :key="index">
                  <span>
                    <p class="message-user">{{ messageItem.locale }}网友</p>
                    <p class="message-text">
                      {{ messageItem.message }}
                    </p>
                    <p class="message-date">
                      {{ timestampToTime(messageItem.dateline * 1000) }}
                    </p>
                  </span>
                </li>
              </ul>
              <p v-if="loading">加载中...</p>
              <p v-if="!loading && noMore" class="message-content_nomore">没有更多了</p>
            </el-scrollbar>
          </div>
          <div class="message-btn-box">
            <div class="message-btn" @click="leaveMes(true)">我要留言</div>
          </div>

          <transition name="messageShow">
            <div class="message-info" v-if="submitMessageShow">
              <div class="message-info-bg"></div>
              <div class="message-info-content">
                <!-- <div class="message-close" @click="toggleSubmitMessageShow(false)"></div> -->
                <div class="textarea-box">
                  <textarea class="message-textarea" maxlength="120" cols="30" rows="30" placeholder="输入文字内容"
                    v-model="message"></textarea>
                  <span class="word-num"> {{ message.length }} / 120</span>
                </div>

                <div class="message-btn-box-publish">
                  <!-- <div class="message-btn-cancle" @click="toggleSubmitMessageShow(false)">
                    取消
                  </div> -->
                  <div class="message-btn-ok" @click="submitMessage">
                    发布留言
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <login v-if="showLogin" @closeLogin="closeLogin"></login>
  </div>
</template>
<script>
import login from "./login";
export default {
  components: {
    login,
  },
  props:{
    isOnly:false
  },
  data() {
    return {
      submitMessageShow: false,
      messageBoxShow: false,
      showLogin: false,
      message: "",
      nickName: "网友",
      userId: "",
      verifycode: "",
      pageIndex: 1,
      messageList: [],
      total: 0,
      loading: false,
    };
  },
  computed: {
    noMore() {
      return this.messageList.length >= this.total;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  methods: {
    toggleSubmitMessageShow(show) {
      this.submitMessageShow = show;
      this.message = "";
    },
    closeMessage() {
      if(this.submitMessageShow) {
        // 关闭发布留言弹窗
        this.toggleSubmitMessageShow(false);
      } else {
        // 关闭留言板弹窗
        this.messageBoxShow = false;
      }
    },
    openMessage() {
      this.messageBoxShow = true;
      this.pageIndex = 1;
      this.loading = false;
      this.messageList = [];
      this.getMessageList();
    },
    leaveMes() {
      // var locPhone = localStorage.getItem("userId");
      // this.userId = this.getCookie1("userSeqId"); // 获取登录ID;
      // this.verifycode = this.getCookie1("verifycode");
      // this.userId = "76632190";
      // this.verifycode =
      //   "token-46427cfc-a9e1-40ce-b06a-bee64f726e63-D44685A0F75545D5023AD0E0E15FC067-6515f386-e5c0-4eb0-bda8-ab82adbff30b";

      // if (this.verifycode) {
        this.toggleSubmitMessageShow(true);
      // } else {
      //   this.showLogin = true;
      // }
    },
    getCookie1(name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },

    closeLogin() {
      this.showLogin = false;
    },
    getMessageList() {
      var that = this;
      this.loading = true;
      $.ajax({
        url: "//common.newcomment.cntv.cn/data/list",
        dataType: "jsonp",
        data: {
          app: "cctvdhd",
          itemid: "2023cibexpo",
          page: this.pageIndex,
        },
        jsonp: "jsonp_callback",
        // jsonpCallback: "2023cibexpo",
        cache: true,
        error: function () {
          console.log("error");
        },
        success: function (data) {
   
          if (data.code == 0) {
            that.messageList = that.messageList.concat(data.data.content);
           
            that.total = data.data.total;
            that.pageIndex++;
            that.loading = false;
          }
        },
      });
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate();
      return Y + M + D;
    },
    submitMessage() {
      var that = this;
      if (this.message) {
        $.ajax({
          url: "//newcomment.cntv.cn/comment/post",
          data: {
            app: "cctvdhd",
            itemid: "2023cibexpo",
            message: this.message,
            data: "2023ppr",
            // verifycode: this.verifycode,
            // author: "网友",
          },
          type: "post",
          async: true,
          dataType: "jsonp",
          jsonp: "jsonp_callback",
          jsonp_callback: "callback_cctvdhd_2023cibexpo",
          success: function (data) {
            
            if (data.code == 0) {
              that.toggleSubmitMessageShow(false);
              that.$message.success("提交成功");
            } else {
              that.$message.error(data.msg);
            }
          },
        });
      } else {
        that.$message.error("请输入留言内容");
      }
    },
  },
  created() { },
};
</script>
<style lang="scss" scoped>
@mixin background-com {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

// .messageShow-active
.messageShow-enter-active,
.messageShow-leave-active {
  transition: opacity 0.5s;
}

.messageShow-enter,
.messageShow-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.leave-message-btn {
  width: 182px;
  height: 62px;
  line-height: 55px;
  cursor: pointer;
  text-align: center;
  color: #ffffff;
  font-size: 20px;
  position: absolute;
  left: 84px;
  bottom: 60px;
  background-image: url("../../assets/img/btn-bg.png");
  @include background-com();

}

.leave-message-box {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;
  .leave-message-bg {
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.5);
    position: absolute;
    left: 0;
    top: 0;
  }

  .leave-message-content {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding-top: 1.86rem;

    .message-head {
      width: 9.87rem;
      height: 0.99rem;
      position: relative;

      background-image: url("../../assets/img/phone/message-header.png");
      @include background-com();
      z-index: 199;
      left: 50%;
      transform: translateX(-50%);
      top: 0;

      font-size: 0.42rem;
      font-family: Source Han Sans CN;
      font-weight: 800;
      color: #FFE1AC;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: 0.2rem;

      .message-close {
        width: 0.44rem;
        height: 0.44rem;
        position: absolute;
        right: 1rem;
        background-image: url("../../assets/img/message-close.png");
        @include background-com();
        cursor: pointer;
      }
    }

    .message-content {
      // width: 1277px;
      width: 8.88rem;
      // height: 725px;
      height: 12rem;
      margin: 0 auto;
      position: relative;
      background-color: #ffd489;
      display: flex;
      flex-direction: column;
      border-radius: 0 0 0.2rem 0.2rem;

      .message-inner-content {
        width: 100%;

        margin: 0 auto;
        overflow: hidden;
        flex: 1;

        .message-inner-ul {
          padding: 0.36rem 0.51rem;
          overflow: hidden;
          // padding: 1em 1em 1em 1em;

          .message-inner-item {
          
            width: 100%;
            margin-bottom: 0.3rem;
            span {
              display: block;
              width: 100%;
      
              min-height: 2.10rem;
              background: #ffffff;
              color: #000;
              padding: 0.3rem;
              border-radius: 0.08rem;
              position: relative;
              text-align: left;
              .message-user {
                font-size: 0.22rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #727272;
                margin-bottom: 0.12rem;
              }

              .message-text {
                font-size: 0.26rem;
                font-family: PingFang SC;
                font-weight: bold;
                color: #010101;
              
                line-height: 0.36rem;
                position: relative;
                padding-bottom: 0.1rem;
                /* 文本超出显示成... */
                // text-overflow: ellipsis;
                // display: -webkit-box;
                // -webkit-box-orient: vertical;
                // /* 设置可显示的行数 */
                // -webkit-line-clamp: 4;
                // overflow: hidden;

                // &::after {
                //   content: "...";
                //   position: absolute;
                //   bottom: 0;
                //   right: 0;
                //   padding: 0 20px 0 10px;
                // }

               
              }
              .message-date {
                position: absolute;
                font-size: 0.22rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: #727272;
                text-align: right;
                bottom: 0.08rem;
                right: 0.16rem;
              }
            }
          }
          // .inner-item-extra {
          //   margin-left: 0.3rem;
          // }
        }
      }
      .message-btn-box {
          width: 100%;
          height: 1.21rem;
          background-color: #ffd489;
          box-shadow: 0 -0.1rem 0.17rem 0 rgba($color: #b37200, $alpha: 0.85);
          padding-top: 0.36rem;
          flex-shrink: 0;
          border-radius: 0 0 0.2rem 0.2rem;

          .message-btn {
            text-align: center;
            width: 1.82rem;
            height: 0.48rem;
            line-height: 0.48rem;
            background-color: #A00000;
            border-radius: 0.5rem;
            margin: 0 auto;
            font-size: 0.20rem;
            font-family: PingFang SC;
            color: #FFDA9A;
            cursor: pointer;
            letter-spacing: 0.01rem;
          }
        }
      .message-btn-box-publish {
          width: 100%;
          height: 1.21rem;
          background-color: #ffd489;
          box-shadow: 0 -0.10rem 0.17rem 0 rgba($color: #b37200, $alpha: 0.85);
          padding-top: 0.35rem;
          flex-shrink: 0;
          border-radius: 0 0 0.20rem 0.2rem;
          .message-btn-cancle {
            width: 1.82rem;
            height: 0.48rem;
            line-height: 0.48rem;
            background-color: #898989;
            font-size: 0.20rem;
            font-family: PingFang SC;
            font-weight: bold;
            color: #FFD489;
            border-radius: 0.5rem;
            display: inline-block;
            cursor: pointer;
          }

          .message-btn-ok {
            width: 1.82rem;
            height: 0.48rem;
            line-height: 0.48rem;
            background-color: #A00000;
            font-size: 0.20rem;
            font-family: PingFang SC;
            font-weight: bold;
            color: #FFD489;
            border-radius: 0.50rem;
            display: inline-block;
            cursor: pointer;
            margin-left: 0.36rem;
          }
      }

        .message-info {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 200;

          .message-info-bg {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }

          .message-close {
            width: 24px;
            height: 24px;
            position: absolute;
            right: 20px;
            top: 18px;
            background-image: url("../../assets/img/message-close.png");
            @include background-com();
            cursor: pointer;
            z-index: 1;
          }

          .message-info-content {
            width: 100%;
            // height: 372px;
            height: 10.78rem;
            position: absolute;
            // bottom: -0.22rem;
            left: 0;

            .textarea-box {
              // width: 1278px;
              width: 100%;
              // height: 242px;
              height: 100%;
              background-image: url("../../assets/img/phone/leavemessage-save-bg.png");
              background-repeat: no-repeat;
              background-size: cover;
              margin: 0 auto;
              position: relative;

              .message-textarea {
                // width: 1222px;
                // height: 166px;
                width: 7.76rem;
                height: 4.48rem;
                background-color: #ffffff;
                border-radius: 0.16rem;
                padding: 0.32rem;
                padding-bottom: 0.60rem;
                font-size: 0.24rem;
                color: #333333;
                border: none;
                outline: none;
                margin-top: 0.36rem;
              }

              .word-num {
                color: #727272;
                font-size: 0.22rem;
                font-family: PingFang SC;
                font-weight: 500;
                position: absolute;
                right: 0.88rem;
                top: 4.24rem;
                // bottom: 0.30rem;
              }
            }

            .message-btn-box {
              width: 100%;
              display: block;
              padding-top: 0.2rem;
              text-align: center;
              border-radius: 0 0 20px 20px;
            }
          }
        }
        .message-content_nomore {
          margin-bottom: 0.40rem;
        }
      }
    }
  }
</style>
<style lang="scss">
.el-scrollbar {
  height: 100%;
}

.message-inner-content .el-scrollbar__bar {
  &.is-vertical {
    width: 0.15rem; //滚动条宽度
    background-color: #c7c7c7;
  }
}

.message-inner-content .el-scrollbar__wrap {
  overflow-y: auto;
  overflow-x: hidden;
}

.message-inner-content .el-scrollbar__thumb {
  ////可设置滚动条颜色
  background-image: url("../../assets/img/scroll-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>